import { useEffect, useState } from "react";
import { Button, Container, Row, Col, Form, Card, Alert } from "react-bootstrap";
import { getTransactionsConfig } from "../../controllers/transactions";
import Loading from "../loading/Loading";
import { findMissingKeys } from "../../controllers/utils";

function Transaccion(props) {
  const comunidadId = props.comunidadId;
  const [config, setConfig] = useState(props.config || '');
  const [fecha, setFecha] = useState(props.date || '');
  const [tipo, setTipo] = useState(props.type || 'deposito');
  const [tipoDeGasto, setTipoDeGasto] = useState(props.expense_type || 'cheque');
  const [cheque, setCheque] = useState(props.check_number || '');
  const [monto, setMonto] = useState(props.amount || '');
  const [reconciliado, setReconciliado] = useState(props.reconciled || 'no');
  const [beneficiario, setBeneficiario] = useState(props.beneficiary || '');
  const [descripcion, setDescripcion] = useState(props.description || '');
  const [categoria, setCategoria] = useState(props.transaction_category_id || '0');
  const [alert, setAlert] = useState();

  const requiredFields = {
    default: ['date', 'comunidadId', 'type', 'amount', 'description', 'transaction_category_id'],
    deposito: [],
    gasto: ['expense_type', 'beneficiary']
  }
  const fieldLabels = {
    date: 'Fecha',
    comunidadId: 'Comunidad',
    type: 'Tipo',
    amount: 'Monto',
    description: 'Descripción',
    transaction_category_id: 'Categoría',
    expense_type: 'Tipo de gasto',
    beneficiary: 'Beneficiario'
  };

  useEffect(() => {
    if (!config) {
      loadConfig();
    }
  }, []);

  const loadConfig = async () => {
    let data = await getTransactionsConfig();
    setConfig(data);
    setCategoria(data.categories[0].transaction_category_id);
  }

  const cancelar = () => {
    if (typeof props.cancelar === 'function') {
      props.cancelar();
    }
  }

  const guardar = async () => {
    const t = {
      transaction_id: props.transactionId,
      date: fecha ? new Date(fecha) : null,
      comunidadId: comunidadId,
      type: tipo, 
      expense_type: tipoDeGasto, 
      check_number: cheque, 
      amount: monto, 
      reconciled: reconciliado === 'si', 
      beneficiary: beneficiario, 
      description: descripcion, 
      transaction_category_id: categoria
    };

    const fields = t.type === 'deposito' ? requiredFields.deposito : requiredFields.gasto;
    const missingKeys = findMissingKeys(t, [...requiredFields.default, ...fields]);

    console.log('missing keys', missingKeys, [...requiredFields.default, ...fields]);

    if (missingKeys.length) {
      setAlert(<Alert variant="danger">
        <p>Por favor revisa la información de la transacción.</p>
        <p>Los siguientes campos deben tener información: {missingKeys.map(k => fieldLabels[k]).join(', ')}</p>
      </Alert>);
      return;
    }
    

    if (typeof props.guardar === 'function') {
      await props.guardar(props.transactionId, t);
    }
  }

  if (!config) {
    return <Card>
      <Card.Body><Loading /></Card.Body>
    </Card>
  }

  return <Card>
    <Card.Body>
      <Container className="transaccion">
        <Row>{alert}</Row>
        <Row>
          <Col md={2}>
            <Form.Group>
              <Form.Label>Fecha</Form.Label>
              <Form.Control type="date" onChange={e => setFecha(e.target.value)} value={fecha}></Form.Control>
            </Form.Group>
          </Col>
          <Col md={2}>
            <Form.Group>
              <Form.Label>Tipo</Form.Label>
              <Form.Select onChange={e => setTipo(e.target.value)} defaultValue={tipo}>
                <option value='deposito'>Depósito</option>
                <option value='gasto'>Gasto</option>
              </Form.Select>
            </Form.Group>
          </Col>

          {tipo === 'gasto' && 
            <Col md={2}>
            <Form.Group>
              <Form.Label>Tipo de gasto</Form.Label>
              <Form.Select onChange={e => setTipoDeGasto(e.target.value)} defaultValue={tipoDeGasto}>
                <option value='cheque'>Cheque</option>
                <option value='efectivo'>Efectivo</option>
                <option value='transferencia'>Transferencia</option>
              </Form.Select>
            </Form.Group>
          </Col>
          }
          {tipo === 'gasto' && tipoDeGasto === 'cheque' &&
            <Col md={2}>
              <Form.Group>
                <Form.Label># cheque</Form.Label>
                <Form.Control type="number" onChange={e => setCheque(e.target.value)} value={cheque}></Form.Control>
              </Form.Group>
            </Col>
          }
          
          <Col md={2} >
            <Form.Group>
              <Form.Label>Monto</Form.Label>
              <Form.Control type="number" onChange={e => setMonto(e.target.value)} value={monto}></Form.Control>
            </Form.Group>
          </Col>
          
          {tipo === 'gasto' &&
            <Col md={3}>
              <Form.Group>
                <Form.Label>Beneficiario</Form.Label>
                <Form.Control type="text" onChange={e => setBeneficiario(e.target.value)} value={beneficiario}></Form.Control>
              </Form.Group>
            </Col>
          }

          <Col md={5}>
            <Form.Group>
              <Form.Label>Descripción</Form.Label>
              <Form.Control type="text" onChange={e => setDescripcion(e.target.value)} value={descripcion}></Form.Control>
            </Form.Group>
          </Col>
          <Col md={2}>
            <Form.Group>
              <Form.Label>Categoría</Form.Label>
              <Form.Select onChange={e => setCategoria(e.target.value)} defaultValue={categoria}>
                {config.categories.map(category => <option value={category.transaction_category_id}>{category.label}</option>)}
              </Form.Select>
            </Form.Group>
          </Col>
          <Col md={2}>
            <Form.Group>
              <Form.Label>Reconciliado</Form.Label>
              <Form.Select onChange={e => setReconciliado(e.target.value)} defaultValue={reconciliado}>
                <option value='no'>No</option>
                <option value='si'>Sí</option>
              </Form.Select>
            </Form.Group>
          </Col>

        </Row>
      </Container>
    </Card.Body>
    <Card.Footer>
      <Row className="actions text-end">
        <Col md={8}></Col>
        {typeof props.cancelar === 'function' && <Col md={2} xs={6}>
          <Button className="btn-secondary" onClick={cancelar}>Cancelar</Button>
        </Col>}
        <Col md={2} xs={6}>
          <Button className="btn-primary" onClick={guardar}>Guardar</Button>
        </Col>
      </Row>
    </Card.Footer>
  </Card>;
}

export default Transaccion;
